import { c as _c } from "react/compiler-runtime";
import { Avatar, Button, HStack, Heading, Icon, Dialog, Stack, Text, VStack, useDisclosure, type StackProps, Badge } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { preventOrphanWords } from '@src/lib/textUtils';
import React, { useState, useRef, useEffect } from 'react';
import { MdStarRate } from 'react-icons/md';
interface PodcastReviewCardProps {
  reviewTitle?: string;
  quote?: string;
  personFullName?: string;
  personFirstName?: string;
  personLastName?: string;
  personTitle?: string;
  personAvatarUrl?: string;
  companyName?: string;
  stars?: string;
  color?: string;
  id?: string;
  stackProps?: StackProps;
}
const PodcastReviewCard: React.FC<PodcastReviewCardProps> = t0 => {
  const $ = _c(88);
  const {
    reviewTitle,
    personFullName,
    personAvatarUrl,
    quote,
    id,
    stackProps
  } = t0;
  const {
    open,
    onOpen,
    onClose
  } = useDisclosure();
  const [showReadMore, setShowReadMore] = useState(false);
  const quoteRef = useRef(null);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const checkOverflow = () => {
        const current = quoteRef.current;
        if (current) {
          const isOverflowing = current.scrollHeight > current.clientHeight;
          setShowReadMore(isOverflowing);
        }
      };
      checkOverflow();
      window.addEventListener("resize", checkOverflow);
      return () => window.removeEventListener("resize", checkOverflow);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 8]);
    $[2] = getBreakpointValue;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== getBreakpointValue) {
    t4 = getBreakpointValue([4, 8]);
    $[4] = getBreakpointValue;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Badge size="md" variant="solid">Startup Therapy Podcast</Badge>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== getBreakpointValue) {
    t6 = getBreakpointValue([4, 8]);
    $[7] = getBreakpointValue;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== getBreakpointValue) {
    t7 = getBreakpointValue([4, 8]);
    $[9] = getBreakpointValue;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== getBreakpointValue) {
    t8 = getBreakpointValue(["lg", "2xl"]);
    $[11] = getBreakpointValue;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== reviewTitle) {
    t9 = preventOrphanWords(reviewTitle);
    $[13] = reviewTitle;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = {
      __html: t9
    };
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t8) {
    t11 = <Heading as="span" fontWeight={600} lineHeight="shorter" size={t8} dangerouslySetInnerHTML={t10} />;
    $[17] = t10;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon>;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <HStack gap={0.5}>{t12}{t13}{t14}{t15}<Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon></HStack>;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t11 || $[26] !== t7) {
    t17 = <Stack align="flex-start" direction="column" gap={t7}>{t11}{t16}</Stack>;
    $[25] = t11;
    $[26] = t7;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== getBreakpointValue) {
    t18 = getBreakpointValue(["sm", "lg", "xl"]);
    $[28] = getBreakpointValue;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== quote || $[31] !== t18) {
    t19 = <Text ref={quoteRef} color="colorPalette.fg" fontFamily="longform" fontSize={t18} fontWeight={400} letterSpacing="normal" lineClamp={5}>{quote}</Text>;
    $[30] = quote;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== onOpen || $[34] !== showReadMore) {
    t20 = showReadMore && <Button size="xs" variant="outline" onClick={onOpen}>Read More</Button>;
    $[33] = onOpen;
    $[34] = showReadMore;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== onClose) {
    t21 = t22 => {
      const {
        open: open_0
      } = t22;
      if (!open_0) {
        onClose();
      }
    };
    $[36] = onClose;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Dialog.Backdrop backdropFilter="blur(10px)" />;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== reviewTitle) {
    t23 = <Heading fontWeight={600} lineHeight="shorter" size="lg">{reviewTitle}</Heading>;
    $[39] = reviewTitle;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon>;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon>;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon>;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon>;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <HStack gap={0.5}>{t24}{t25}{t26}{t27}<Icon asChild={true} boxSize={4} color="yellow.600"><MdStarRate /></Icon></HStack>;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== t23) {
    t29 = <Dialog.Header><Stack align="flex-start" direction="column" gap={2}>{t23}{t28}</Stack></Dialog.Header>;
    $[46] = t23;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Dialog.CloseTrigger />;
    $[48] = t30;
  } else {
    t30 = $[48];
  }
  let t31;
  if ($[49] !== quote) {
    t31 = <Text color="textPrimary" fontFamily="longform" fontSize="lg" fontWeight={400} letterSpacing="normal">{quote}</Text>;
    $[49] = quote;
    $[50] = t31;
  } else {
    t31 = $[50];
  }
  let t32;
  if ($[51] !== personAvatarUrl) {
    t32 = personAvatarUrl ? <Avatar.Root bgColor="primary" size="xs"><Avatar.Fallback /><Avatar.Image src={personAvatarUrl} /></Avatar.Root> : undefined;
    $[51] = personAvatarUrl;
    $[52] = t32;
  } else {
    t32 = $[52];
  }
  let t33;
  if ($[53] !== personFullName) {
    t33 = <Text textStyle="labelSm">@{personFullName}</Text>;
    $[53] = personFullName;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  let t34;
  if ($[55] !== t32 || $[56] !== t33) {
    t34 = <HStack>{t32}{t33}</HStack>;
    $[55] = t32;
    $[56] = t33;
    $[57] = t34;
  } else {
    t34 = $[57];
  }
  let t35;
  if ($[58] !== t31 || $[59] !== t34) {
    t35 = <Dialog.Body><VStack align="flex-start" gap={10} width="full">{t31}{t34}</VStack></Dialog.Body>;
    $[58] = t31;
    $[59] = t34;
    $[60] = t35;
  } else {
    t35 = $[60];
  }
  let t36;
  if ($[61] !== t29 || $[62] !== t35) {
    t36 = <Dialog.Positioner><Dialog.Content bgColor="black" borderRadius="2xl" padding={10}>{t29}{t30}{t35}</Dialog.Content></Dialog.Positioner>;
    $[61] = t29;
    $[62] = t35;
    $[63] = t36;
  } else {
    t36 = $[63];
  }
  let t37;
  if ($[64] !== open || $[65] !== t21 || $[66] !== t36) {
    t37 = <Dialog.Root open={open} onOpenChange={t21}>{t22}{t36}</Dialog.Root>;
    $[64] = open;
    $[65] = t21;
    $[66] = t36;
    $[67] = t37;
  } else {
    t37 = $[67];
  }
  let t38;
  if ($[68] !== t17 || $[69] !== t19 || $[70] !== t20 || $[71] !== t37 || $[72] !== t6) {
    t38 = <VStack align="flex-start" gap={t6}>{t17}{t19}{t20}{t37}</VStack>;
    $[68] = t17;
    $[69] = t19;
    $[70] = t20;
    $[71] = t37;
    $[72] = t6;
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  let t39;
  if ($[74] !== personAvatarUrl) {
    t39 = personAvatarUrl ? <Avatar.Root bgColor="primary" size="xs"><Avatar.Fallback /><Avatar.Image src={personAvatarUrl} /></Avatar.Root> : undefined;
    $[74] = personAvatarUrl;
    $[75] = t39;
  } else {
    t39 = $[75];
  }
  let t40;
  if ($[76] !== personFullName) {
    t40 = <Text textStyle="labelSm">@{personFullName}</Text>;
    $[76] = personFullName;
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  let t41;
  if ($[78] !== t39 || $[79] !== t40) {
    t41 = <HStack borderTop="1px solid {colors.colorPalette.border/50}" paddingTop={6} width="full">{t39}{t40}</HStack>;
    $[78] = t39;
    $[79] = t40;
    $[80] = t41;
  } else {
    t41 = $[80];
  }
  let t42;
  if ($[81] !== id || $[82] !== stackProps || $[83] !== t3 || $[84] !== t38 || $[85] !== t4 || $[86] !== t41) {
    t42 = <VStack alignItems="flex-start" alignSelf="stretch" borderRadius="2xl" boxShadow="sm" gap={t3} id={id} justify="space-between" overflow="hidden" padding={t4} width="full" {...stackProps}>{t5}{t38}{t41}</VStack>;
    $[81] = id;
    $[82] = stackProps;
    $[83] = t3;
    $[84] = t38;
    $[85] = t4;
    $[86] = t41;
    $[87] = t42;
  } else {
    t42 = $[87];
  }
  return t42;
};
export default PodcastReviewCard;